import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectAi = (state: RootState) => state.ai;

export const selectAiPrompts = createSelector(selectAi, ai => ai.prompts);

export const selectAiPromptsData = createSelector(
  selectAiPrompts,
  prompts => prompts.data
);

export const selectAiPromptsLoading = createSelector(
  selectAiPrompts,
  prompts => prompts.loading
);
